module.exports = __webpack_public_path__ + "img/step44_a_printer_basic_fix_screws.8598339f.png";